import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import {
  validString,
  fullContact,
  addressLine,
  postcode,
  city,
  state,
  validName,
  email,
} from "Components/shared/helpers/validations";
import { fullName } from "Utils/validations";

export const ParcelOrderInfoSchema = Yup.object().shape(
  reverseShape({
    senderType: validString.required(),
    customer: Yup.string().required().concat(fullName),
    individualName: validString.required(),
    customerLocation: validString.required(),
    emailAddress: email.required(),
    contactNo: fullContact.required(),
    street1: addressLine.required(),
    postcode: postcode.required(),
    city: city.required(),
    state: state.required(),
    country: validString.required(),
  })
);

export default ParcelOrderInfoSchema;
